export const maskToUSNumber = (value: string) => {
  return `+1${value.replace(/\(|\s|\)|-/g, '')}`;
};

/**
 * Normalizes phone number to exactly 12 digits for NERIS API
 * Removes all non-numeric characters (including +) and ensures 12-digit format
 * Database can store with + (e.g., "+17081972534"), but API requires exactly 12 digits without +
 * @param phoneNumber - Phone number in any format (e.g., "+17081972534", "(708) 197-5466", etc.)
 * @returns Phone number as exactly 12 digits without + (e.g., "17081972534")
 */
export const normalizePhoneForNeris = (
  phoneNumber: string | undefined,
): string => {
  if (!phoneNumber) return '';

  // Remove all non-numeric characters (including +, dashes, brackets, spaces, etc.)
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  // Handle different input formats:
  // - "+17081972534" (13 chars with +) -> "17081972534" (12 digits)
  // - "17081972534" (12 digits) -> "17081972534" (already correct)
  // - "7081975466" (10 digits) -> "17081975466" (add leading 1)

  if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    return digitsOnly; // Already 12 digits (1 + 10 digit US number)
  }

  if (digitsOnly.length === 10) {
    return `1${digitsOnly}`; // Add leading 1 for US numbers
  }

  if (digitsOnly.length > 12) {
    // Take the last 12 digits if longer
    return digitsOnly.slice(-12);
  }

  if (digitsOnly.length < 12 && digitsOnly.length > 0) {
    // Pad with leading 1s if shorter (but not empty)
    return '1'.repeat(12 - digitsOnly.length) + digitsOnly;
  }

  return digitsOnly; // Already exactly 12 digits
};

export const usNumberToMask = (value: string) => {
  const phoneNumber = value.replace('+1', '');
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6)}`;
};
